import FormField from 'components/community/common/FormField';
import { Box } from 'components/molecules/utils/basicComponents';
import { getCustomScroll } from 'components/molecules/utils/customStyles';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { StyledSvgSprite } from '../../../../general/SVGSprite';
import { InputBox } from '../commonComponents';

export const EndDate = ({
    formData,
    setTypeDateTime,
    setShowSideMenu,
    getMinDate,
    newOnBoardingFlow = false,
    isCreateAirmeetV3 = false,
}) => (
    <StyledBox
        onClick={() => {
            setTypeDateTime('date');
            setShowSideMenu('ending_on');
        }}
    >
        <FormFieldWIcon
            id={'finalDate'}
            name={'finalDate'}
            custom
            variant={'v2'}
            label={`End date${isCreateAirmeetV3 ? '*' : ''}`}
            subLabel={isCreateAirmeetV3 ? '' : 'Event end date'}
            filledValue={formData.finalDate}
            // isError={errorMap.finalDate && errorMap.finalDate.status}
            disabled={true}
            newOnBoardingFlow={newOnBoardingFlow}
        >
            <InputBox>{moment(formData.finalDate).format('ll')}</InputBox>
            <StyledSvgSprite
                position={'absolute'}
                top={'20px'}
                right={'18px'}
                icon={'calendar-icon'}
                height={16}
                width={16}
                fill={'ambience.8'}
            />
        </FormFieldWIcon>
    </StyledBox>
);

const StyledBox = styled(Box)`
    width: 100%;
    max-width: 250px;
    margin-right: 25px;
    &:last-child {
        margin-right: 0;
    }
    .custom-time-dropdown {
        margin-top: 0px;
        width: 100%;
        max-width: 100%;
        z-index: 2;
        .react-datepicker {
            font-family: ${({ theme }) => theme.fonts.book};
            background-color: ${({ theme }) => theme.colors.ambience[1]};
            border-radius: 8px;
            overflow: hidden;
            border: 0;
            width: 100%;
            .react-datepicker__time-container {
                width: 100%;
                .react-datepicker__header--time {
                    display: none;
                }
                .react-datepicker__time {
                    background-color: ${({ theme }) =>
                        theme.colors.ambience[1]};
                    border-radius: 0;
                    .react-datepicker__time-box {
                        width: 100%;
                        .react-datepicker__time-list {
                            ${({ theme, forceDarkMode }) =>
                                getCustomScroll({ theme, forceDarkMode })};
                            max-height: 164px;
                            overflow-y: auto;
                            padding: 16px 0;
                            .react-datepicker__time-list-item {
                                width: 100%;
                                margin: 0;
                                padding: 10px 16px;
                                height: unset;
                                font-size: 14px;
                                line-height: 16px;
                                text-align: left;
                                transition: all 0.3s ease-in-out;
                                text-transform: lowercase;
                                color: ${({ theme }) =>
                                    theme.colors.ambience[18]};
                                &.react-datepicker__time-list-item--disabled {
                                    opacity: 0.5;
                                    &:hover {
                                        background-color: transparent;
                                    }
                                }
                                &.react-datepicker__time-list-item {
                                    background-color: transparent;
                                }
                                &:first-child {
                                    padding-top: 0;
                                }
                                &:last-child {
                                    padding-bottom: 0;
                                }
                                &:hover {
                                    background-color: ${({ theme }) =>
                                        theme.colors.ambience[2]};
                                }
                            }
                        }
                    }
                }
            }
            .react-datepicker__triangle {
                display: none;
            }
        }
    }
`;

const FormFieldWIcon = styled(FormField)`
    ${({ forTimePicker }) =>
        forTimePicker &&
        `
    &.form-field {
        padding:0 !important;
    }
    .react-datepicker__input-container {
        input {
            cursor: pointer;
            padding: 18px 40px 16px 17px;
        }
    }
    `};
    &.form-field {
        cursor: pointer;
    }
    .react-datepicker-wrapper {
        width: 100%;
    }
    .react-datepicker__input-container {
        position: relative;
        z-index: 1;
        input {
            cursor: pointer;
            padding-right: 20px;
            color: ${({ theme }) => theme.colors.ambience[2]} !important;
            font-family: ${({ theme }) => theme.fonts.book} !important;
            font-size: 14px !important;
        }
    }
`;
